import React from 'react';
import PropTypes from 'prop-types';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles';
import HamburgerButton from './HamburgerButton';

const styles = theme => ({
    root: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    navIconHide: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    logo: {
        width: '28px',
        height: '20px',
    },
});

function AppToolbar(props) {
    return (
        <div className={props.classes.root}>
            <AppBar color="secondary">
                <Toolbar>
                    <HamburgerButton />
                    <Typography
                        variant="title"
                        color="inherit"
                    >
                        SGL Fintech
                    </Typography>
                </Toolbar>
            </AppBar>
        </div>
    );
}

AppToolbar.propTypes = {
    title: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AppToolbar);



// WEBPACK FOOTER //
// ./src/app/layout/AppToolbar.js